import './App.css';
import {AppBar, Box, Button, Container, ThemeProvider, Toolbar, Tooltip} from "@mui/material";
import {LanguageContext} from "./context/LanguageContext";
import {useContext} from "react";
import {languageOptions} from "./languages";
import {Language} from "@mui/icons-material";
import Footer from "./components/Footer";
import Registration from "./components/Registration";
import {CompanyEnvironmentContext} from "./context/CompanyEnvironmentContext";
import {createTheme} from "@mui/material/styles";

function App() {
  const companyEnvironmentContext = useContext(CompanyEnvironmentContext);
  const languageContext = useContext(LanguageContext);
  const theme = createTheme(companyEnvironmentContext.theme);

  const handleLanguageChange = event => {
    let selectedLanguage;
    const lang = languageContext.language.id;
    if (lang === "hu") {
      selectedLanguage = languageOptions.find(item => item.id === "en");
    } else {
      selectedLanguage = languageOptions.find(item => item.id === "hu");
    }
    languageContext.setLanguage(selectedLanguage);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box className="App" sx={{backgroundColor: "primary.bgColor"}}>
        <Box sx={{flexGrow: 1}}>
          <AppBar position="static">
            <Toolbar sx={{backgroundColor: "white", justifyContent: "space-between"}}>
              <img
                src={companyEnvironmentContext.logos.fullLightBg}
                alt={companyEnvironmentContext.companyEnvironment}
                style={{maxHeight: theme.spacing(6)}}
              />
              <Tooltip title={languageContext.dictionary.changeLanguage}>
                <Button
                  color="primary"
                  onClick={handleLanguageChange}
                  size="small"
                  sx={{margin: 0.5}}
                >
                  <Language sx={{marginRight: 0.5}}/>
                  {languageContext.language.id}
                </Button>
              </Tooltip>
            </Toolbar>
          </AppBar>
        </Box>
        <Container maxWidth="md" sx={{paddingTop: 6, paddingBottom: 12}}>
          <Registration/>
        </Container>
        <Footer/>
      </Box>
    </ThemeProvider>
  );
}

export default App;
